(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ventana-card-colors"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const more=event.target.closest('.ventana-card-colors__more');
  if(more){event.preventDefault();event.stopPropagation();more.closest('[data-card-colors]').querySelectorAll('[hidden]').forEach(el=>{el.hidden=false;el.querySelectorAll('[data-swatch-src]').forEach(img=>{img.src=img.dataset.swatchSrc;img.removeAttribute('data-swatch-src');});});more.setAttribute('aria-expanded','true');more.hidden=true;return;}
  const swatch=event.target.closest('.ventana-card-colors__swatch');
  if(!swatch||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  const card=swatch.closest('.product-card');
  if(!card)return;
  event.preventDefault();event.stopPropagation();
  card.querySelectorAll('[data-card-colors] a').forEach(el=>el.removeAttribute('aria-current'));
  swatch.setAttribute('aria-current','true');
  card.querySelectorAll('a.full-width-link').forEach(link=>link.href=swatch.href);
  const img=card.querySelector('.product-card__image-wrapper img');
  if(img&&swatch.dataset.colorImage){
    img.classList.remove('lazyload','lazyloading');img.classList.add('lazyloaded');
    ['srcset','data-src','data-srcset','data-widths','data-sizes'].forEach(name=>img.removeAttribute(name));
    img.src=swatch.dataset.colorImage;img.alt=swatch.dataset.colorAlt;
  }
});
  } catch(e) { console.error(e); }
})();

})();
